/** Performs a full-page replacement navigation to the provided URL. */
export const replaceLocation = (url: string): void => {
  window.location.replace(url);
};
